<template>
    <img :src="url" v-bind:class="size" @click="_click"/>
</template>

<script>
export default {
    name: 'iconimg',
    props: {
        name: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: "default"
        }
    },
    data() {
        return {
            url: '',
            static_images: {
                assets: '/static/icon/assets.png',
                copy: '/static/icon/copy.png',
                deposithistory: '/static/icon/deposithistory.png',
                network: '/static/icon/network.png',
                usdt: '/static/icon/usdt.png',
                noassets: '/static/icon/noassets.png',
                recharge: '/static/icon/recharge.png',
                withdraw: '/static/icon/withdraw.png',
                payment_method: '/static/icon/payment_method.png',
                service: '/static/icon/service.png',
                withdrawlog: '/static/icon/withdrawlog.png',
                edit: '/static/icon/edit.png',
                i: '/static/icon/i.png',
                inpaying: '/static/icon/inpaying.png',
                profit: '/static/icon/profit.png',
                kyc: '/static/icon/kyc.png',
                bharatpe: '/static/icon/bharatpe.png',
                cubbank: '/static/icon/cubbank.png',
                freecharge: '/static/icon/freecharge.png',
                airtel: '/static/icon/airtel.jpg',
                induspay:'/static/icon/IndusPay.webp',
                mobikwik: '/static/icon/mobikwik.png',
                icicibank: '/static/icon/icicbank.jpg',
                paytm: '/static/icon/paytm.png',
                phonepe: '/static/icon/phonepe.png',
                add: '/static/icon/add.png',
                whatsapp: '/static/icon/whatsapp.png',
                telegram: '/static/icon/telegram.png',
                search: '/static/icon/search.png',
                gift: '/static/icon/gift.png',
                warning: '/static/icon/warning.png',
                batch: '/static/icon/batch.png',
                registersuccess: '/static/icon/registersuccess.png',
                team: '/static/icon/team.png',
                A: '/static/icon/A.png',
                B: '/static/icon/B.png',
                C: '/static/icon/C.png',
                paying: '/static/icon/paying.png',
                kyc_positive: '/static/icon/kyc_positive.png',
                kyc_negative: '/static/icon/kyc_negative.png',
                leader: '/static/icon/leader.png',
                commission: '/static/icon/commission.png',
                logo: '/static/images/siilogo.png',
                bank: '/static/icon/bank.png',
                video: '/static/icon/video.png',
                index_logo: '/static/icon/sii-logo.png',
                notice: '/static/icon/notice.png',
                phone: '/static/icon/phone.png',
                password: '/static/icon/password.png',
                share_link: '/static/icon/share_link.png',
                dividend: '/static/icon/dividend.png',
                yesterday: '/static/icon/yesterday.png',
                today: '/static/icon/today.png',
                agent: '/static/icon/agent.png',
                upi: '/static/icon/upi.png',
            }
        }
    },
    created() {
        this.url = this.static_images[this.name]
    },
    methods: {
        _click() {
            this.$emit("click")
        }
    }
    
}

</script>

<style scoped>
.default {
    width: 0.42rem;
    height: 0.42rem;
}
.xxl{
    width: 0.88rem;
    height: 0.88rem;
}
.xl{
    width: 0.64rem;
    height: 0.64rem;
}
.x{
    width: 0.51rem;
    height: 0.51rem;
}
.lg {
    width: 0.42rem;
    height: 0.42rem;
}

.xs {
    width: 0.2rem;
    height: 0.2rem;
}

.sm {
    width: 0.24rem;
    height: 0.24rem;
}

.md {
    width: 0.32rem;
    height: 0.32rem;
}
</style>



// WEBPACK FOOTER //
// src/components/iconimg.vue